import type { FaireProductEntity } from "../../entity_types/product";

export const p_jftm2z6968: FaireProductEntity = {
  token: "p_jftm2z6968",
  type: "product",
  name: "Hair Towel Wrap Double Sided- RJW Glitz",
  brandToken: "b_ci67w2i6k6",
  brandName: "Once Again Home Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/888a848814918b9b18046df181f5d46c1d87e4abf2d123bdbe7d0574ee98dbb9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78092dc48031aff2fd80b9fe698ea9e45b8ad554e505cf4f544a801065855cf7.png",
    "https://cdn.faire.com/fastly/80bb938f1ee1c6e2ea61aaf1499e42f76cb7f2b0342fd6ebe9a6833d371ab26a.png",
    "https://cdn.faire.com/fastly/2d6ed6a96af9e7c08286468d4189e8f955ca0a782d54f81c51d9708f4d1ee907.png",
    "https://cdn.faire.com/fastly/c45acecf087b7fb2c486d3e6a0fa8a1dd5b7534322d4eedd697b0e039fe085f7.png",
  ],
  priceDollars: 13.93,
  description:
    "Style:  The Glitz Collection features Navy Ground Damask-Inspired Florals with Pops of Vibrant Colors like Pink and Red. It's Reverse is a Soothing Blue Wave. \n\nPerfect Uses: Efficiently Dry Hair and Reduce Frizz with this Innovative Towel.\n\n\nRecycled Impact: 3 Bottles were Recycled in making this Set.\n\n\nSizes: Oversized for all Lengths of Hair. One Size fits Most.\n\n\nDual-Sided Print: Yes.\n\nIncludes: Towel with Button Closure and Hanging Loop.\n\n\nMaterial: Made with Certified Recycled Post-consumer Materials. 80% Recycled Polyester, 20% Polyamide.\n\n\nCare: Machine Wash, No Bleach, No Fabric Softener, Tumble Dry.",
  tags: [],
  msrpDollars: 27.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:41.544Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
